import React from 'react'

const Messaging = () => {
  return (
    <div className="container">Messaging</div>
  )
}

export default Messaging